import RequestAbstract from "../abstract";

export default class PartnerAccounts extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/partner-accounts";
    }
}
